import React, { useEffect, useState, useMemo } from "react";
import { Typography } from "antd";
import "./SiderComponent.css";
import Sider from "antd/es/layout/Sider";
import { Sentinel } from "./model_gen/sentinel";
import { usePermissions } from "./PermissionsProvider";
import ConfigComponent from "./ConfigComponent";

// Define the props interface
interface LeftSiderComponentProps {
  considerTourStep: (step: number) => void;
  tripFault: (sentinel: Sentinel) => void;
  models: string[];
  setModels: (models: string[]) => void;
  temperature: number;
  setTemperature: (temperature: number) => void;
  evaluations: boolean;
  setEvaluations: (evaluations: boolean) => void;
  autocorrect: boolean;
  setAutocorrect: (autocorrect: boolean) => void;
  retrieveContext: boolean;
  setRetrieveContext: (retrieveContext: boolean) => void;
  streaming: boolean;
  setStreaming: (streaming: boolean) => void;
  agentId?: number | null;
  setAgentId?: (agentId: number | null) => void;
  agentSettings?: any;
  setAgentSettings?: (settings: any | null) => void;
  onModelCategoryChange?: (category: string) => void;
}

const LeftSiderComponent: React.FC<LeftSiderComponentProps> = ({
  considerTourStep,
  tripFault,
  models,
  setModels,
  temperature,
  setTemperature,
  evaluations,
  setEvaluations,
  autocorrect,
  setAutocorrect,
  retrieveContext,
  setRetrieveContext,
  streaming,
  setStreaming,
  agentId,
  setAgentId,
  agentSettings,
  setAgentSettings,
  onModelCategoryChange,
}) => {

  const { apiKey } = usePermissions();
  const [sentinels, setSentinels] = useState<Sentinel[]>([]);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Memoize SiderContent to prevent remounting when props change
  const SiderContent = useMemo(
    () => (
      <div className={`left-sider-content ${isMobile ? "mobile" : ""}`}>
        {!isMobile && (
          <Typography
            style={{
              fontSize: "20px",
              fontWeight: "700",
              color: "rgba(0,0,0,0.2)",
              textAlign: "center",
              marginBottom: "20px",
            }}>
            Configuration
          </Typography>
        )}
        <ConfigComponent
          models={models}
          setModels={setModels}
          temperature={temperature}
          setTemperature={setTemperature}
          evaluations={evaluations}
          setEvaluations={setEvaluations}
          autocorrect={autocorrect}
          setAutocorrect={setAutocorrect}
          retrieveContext={retrieveContext}
          setRetrieveContext={setRetrieveContext}
          streaming={streaming}
          setStreaming={setStreaming}
          agentId={agentId}
          setAgentId={setAgentId}
          agentSettings={agentSettings}
          setAgentSettings={setAgentSettings}
          onModelCategoryChange={onModelCategoryChange}
        />
        {/* <hr style={{margin: "30px 0", color: "rgba(0,0,0,0.1)", border: "1px solid rgba(0,0,0,0.02)"}} />
      <Typography style={{
        fontSize: "20px", 
        fontWeight: "700", 
        color: "rgba(0,0,0,0.2)", 
        textAlign: "center", 
        marginBottom: "20px"
      }}>
        Sentinels
      </Typography>
      <div style={{marginBottom: '10px'}}>
        {loading && 
          <Typography style={{textAlign: 'center'}}>Loading sentinels...</Typography>
        }
      </div>
      {(sentinels.length > 0) ? (
        <Menu mode="vertical" style={{marginTop: '10px'}}>
          {sentinels?.map((sentinel, index) => (
            <SentinelComponent key={sentinel.id} sentinel={sentinel}/>
          ))}
        </Menu>
      ) : (
        <div style={{
          width: '100%', 
          height: 'auto', 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          background: 'rgba(0,0,0,0.05)', 
          borderRadius: '10px', 
          padding: isMobile ? 20 : 40
        }}>
          {loading || loadingApplication ? (
            <Spin size="large" />
          ) : (
            <Typography style={{
              fontSize: isMobile ? '16px' : '18px', 
              color: 'rgba(0,0,0,0.2)', 
              textAlign: 'center'
            }}>
              {mappedApplication ? "No active sentinels with severity >= 3" : "Choose an application to see applicable Sentinels"}
            </Typography>
          )}
        </div>
      )} */}
      </div>
    ),
    [
      isMobile,
      models,
      setModels,
      temperature,
      setTemperature,
      evaluations,
      setEvaluations,
      autocorrect,
      setAutocorrect,
      retrieveContext,
      setRetrieveContext,
      streaming,
      setStreaming,
      agentId,
      setAgentId,
      agentSettings,
      setAgentSettings,
      onModelCategoryChange,
    ]
  );

  // If rendered within a drawer, don't use Sider component
  if (isMobile) {
    return SiderContent;
  }

  return (
    <Sider width={400} className="LeftSider">
      {SiderContent}
    </Sider>
  );
};

export default LeftSiderComponent;
